import { Component, Input, Output } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, finalize, filter } from 'rxjs/operators';

// CONFIGS
import { IAppIntegrationShippingPreset } from '../../../app-integration-account/intefaces/app-integration.interface';
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';
import { ShipstationApiService } from '../../../shared/services/api/shipstation-api.service';

import { SalesOrderConfig } from './../../configs/sales-order.config';

// INTERFACES

// SERVICES

@Component({
  selector: 'lum-sales-order-sidebar-bulk-update',
  templateUrl: './sales-order-sidebar-bulk-update.component.html',
  styleUrls: ['./sales-order-sidebar-bulk-update.component.scss'],
})
export class SalesOrderSidebarBulkUpdateComponent {
  @Input()
  currentPreset :IAppIntegrationShippingPreset | null = null;

  @Input()
  hasSameAppIntegrationId :boolean = false;

  @Input()
  commonAppIntegrationAccountId :number | null = null;

  @Input()
  selectedRows :any[] = [];

  @Input()
  appIntegrationAccountId :number | null = null;

  @Output()
  bulkUpdateSuccessEvent = new Subject<boolean>();

  shippingOptions = SalesOrderConfig.shippingOptions;

  private onDestroy$ = new Subject();
  private loadingBulkUpdateShippingLabel$ = new BehaviorSubject<boolean>(false);

  constructor(
    private shipstationApiService :ShipstationApiService,
    private snackbar :MatSnackBar,
  ) {}

  onSubmit(value :any) :void {
    this.loadingBulkUpdateShippingLabel$.next(true);
    this.shipstationApiService
      .bulkUpdateShippingLabel({
        ...value,
        lineItems: this.selectedRows,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.loadingBulkUpdateShippingLabel$.next(false);
        }),
      )
      .subscribe({
        next: (response :string) => {
          this.snackbar.open(response, 'Dismiss', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.bulkUpdateSuccessEvent.next(true);
        },
        error: (error :any) => {
          this.snackbar.open(error || 'Failed update selected rows.', 'Dismiss', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.bulkUpdateSuccessEvent.next(false);
        },
      });
  }

  get loadingBulkUpdateShippingLabel() :boolean {
    return this.loadingBulkUpdateShippingLabel$.value;
  }

  get bulkUpdateWarningMessage() :string {
    if (this.selectedRows.length === 0) {
      return 'No items selected.';
    }

    const accountIdsPerItem = this.selectedRows.map(
      (item) => item.channel?.pullOrderIntegrationMapping?.appIntegrationAccountId,
    );

    const uniqueAccountId = accountIdsPerItem[0];
    for (let i = 1; i < accountIdsPerItem.length; i++) {
      if (accountIdsPerItem[i] !== uniqueAccountId) {
        return 'Selected items belong to different OMS.';
      }
    }

    return '';
  }
}
